// Mirrors the backend SECRET_PLACEHOLDER_PATTERN.
const SECRET_PLACEHOLDER_REGEX = /\[\[[^\]]+\]\]/g;

// Scans string leaves (dict keys + values, not a JSON.stringify blob) so nested-array brackets (e.g. Sheets values:[[...]]) aren't misread.
const collectStrings = (value: unknown): string[] => {
  if (typeof value === 'string') return [value];
  if (Array.isArray(value)) return value.flatMap(collectStrings);
  if (value && typeof value === 'object')
    return Object.entries(value).flatMap(([key, val]) => [key, ...collectStrings(val)]);
  return [];
};

// Unique, sorted [[placeholder]] markers /from_text leaves for the developer; any remaining one keeps the action invalid.
export const findSecretPlaceholders = (...values: unknown[]): string[] => {
  const matches = values
    .flatMap(collectStrings)
    .flatMap((text) => text.match(SECRET_PLACEHOLDER_REGEX) ?? []);
  return matches.length ? [...new Set(matches)].sort() : [];
};
